import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useCart } from "../../contexts/CartContext";

const NAV_LINKS = [
  { label: "首頁", path: "/" },
  { label: "商品館", path: "/shop" },
  { label: "聯絡我們", path: "/contact" },
];

export default function Navbar() {
  const { totalCount, openCart } = useCart();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";
  const isTransparent = isHome && !scrolled;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isTransparent
          ? "bg-transparent"
          : "bg-[#1B4332] shadow-lg shadow-black/20"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/064db44d-4777-4c03-bf36-b7c201482d38.png"
            alt="Brand Logo"
            className="h-9 w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm tracking-widest transition-all duration-200 cursor-pointer whitespace-nowrap ${
                location.pathname === link.path
                  ? "text-white font-medium"
                  : "text-white/60 hover:text-white"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Right actions */}
        <div className="flex items-center gap-4">
          <Link
            to="/shop"
            className="hidden md:inline-flex items-center justify-center px-5 py-2 text-sm text-[#1B4332] bg-white rounded-sm font-medium tracking-wider hover:bg-white/90 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            立即購買
          </Link>

          {/* Cart button */}
          <button
            onClick={openCart}
            className="relative w-10 h-10 flex items-center justify-center text-white hover:text-white/70 transition-colors duration-200 cursor-pointer"
            aria-label="購物車"
          >
            <i className="ri-shopping-bag-line text-xl"></i>
            {totalCount > 0 && (
              <span className="absolute -top-0.5 -right-0.5 w-5 h-5 flex items-center justify-center bg-white text-[#1B4332] text-xs font-bold rounded-full">
                {totalCount > 9 ? "9+" : totalCount}
              </span>
            )}
          </button>

          {/* Mobile hamburger */}
          <button
            onClick={() => setMobileOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
            aria-label="選單"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden bg-[#1B4332] border-t border-white/10 overflow-hidden transition-all duration-300 ${
          mobileOpen ? "max-h-64 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <nav className="px-6 py-4 flex flex-col gap-4">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm tracking-widest cursor-pointer ${
                location.pathname === link.path ? "text-white font-medium" : "text-white/60"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/shop"
            className="inline-flex items-center justify-center px-5 py-2.5 text-sm text-[#1B4332] bg-white rounded-sm font-medium tracking-wider cursor-pointer whitespace-nowrap w-fit"
          >
            立即購買
          </Link>
        </nav>
      </div>
    </header>
  );
}
